var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-combobox', _vm._b({
    attrs: {
      "label": "리스트",
      "placeholder": "Tab을 누르면 항목이 추가됩니다",
      "item-text": "term",
      "small-chips": "",
      "multiple": ""
    },
    on: {
      "change": _vm.setListItems
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
          item = _ref.item,
          parent = _ref.parent;
        return [_c('v-chip', _vm._b({
          staticClass: "rounded-0",
          attrs: {
            "input-value": !item.isIt,
            "small": "",
            "outlined": "",
            "color": "grey darken-4",
            "text-color": "grey darken-4"
          },
          on: {
            "click": function click($event) {
              (item.isIt = !item.isIt) && _vm.emit();
            }
          }
        }, 'v-chip', attrs, false), [_c('span', {
          staticClass: "pr-2"
        }, [_vm._v(" " + _vm._s(item.term) + " ")]), _c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function click($event) {
              (parent.selectItem(item) || true) && _vm.emit();
            }
          }
        }, [_vm._v(" $delete ")])], 1)];
      }
    }]),
    model: {
      value: _vm.list,
      callback: function callback($$v) {
        _vm.list = $$v;
      },
      expression: "list"
    }
  }, 'v-combobox', _vm.$attrs, false));
}
var staticRenderFns = []

export { render, staticRenderFns }